export default __webpack_public_path__ + "static/media/icw-funnel.8d9c315e.jpg";